import { RecommendedProductItem, TopSellingProduct } from '@/types/algonomy';

class TopSellingDTO {
  private recommendedProductItem;

  constructor(recommendedProductItem: RecommendedProductItem) {
    this.recommendedProductItem = recommendedProductItem;
  }

  public get getProduct(): TopSellingProduct {
    return {
      clickTrackingURL: this.recommendedProductItem.clickTrackingURL,
      imageId: this.recommendedProductItem.imageURL,
      linkId: this.recommendedProductItem.productURL,
      name: this.recommendedProductItem.name,
      numReviews: this.recommendedProductItem.numReviews,
      rating: this.recommendedProductItem.rating,
      priceCents: this.recommendedProductItem.priceCents,
      salePriceCents: this.recommendedProductItem.salePriceCents || -1,
      new: this.recommendedProductItem.attributes?.New ? this.recommendedProductItem.attributes.New[0] === '1' : false,
      newPriceMax: this.recommendedProductItem.attributes?.NewPriceMax
        ? this.recommendedProductItem.attributes.NewPriceMax[0]
        : undefined,
      newPriceMin: this.recommendedProductItem.attributes?.NewPriceMin
        ? this.recommendedProductItem.attributes.NewPriceMin[0]
        : undefined,
      newSalePriceMax: this.recommendedProductItem.attributes?.NewSalePriceMax
        ? this.recommendedProductItem.attributes.NewSalePriceMax[0]
        : undefined,
      newSalePriceMin: this.recommendedProductItem.attributes?.NewSalePriceMin
        ? this.recommendedProductItem.attributes.NewSalePriceMin[0]
        : undefined,
      usedPriceCents: this.recommendedProductItem.attributes?.UsedAnyPriceMin
        ? this.recommendedProductItem.attributes.UsedAnyPriceMin[0]
        : undefined,
      pricePerUnit: this.recommendedProductItem.attributes?.PricePerUnit
        ? this.recommendedProductItem.attributes.PricePerUnit[0]
        : undefined,
      pricePerUnitLabel: this.recommendedProductItem.attributes?.PricePerUnitLabel
        ? this.recommendedProductItem.attributes.PricePerUnitLabel[0]
        : undefined,
      productConditionMax: this.recommendedProductItem.attributes?.ProductConditionMax
        ? this.recommendedProductItem.attributes.ProductConditionMax[0]
        : this.recommendedProductItem.attributes?.ProductCondition
        ? this.recommendedProductItem.attributes.ProductCondition[0]
        : undefined,
      productCondition: this.recommendedProductItem.attributes?.ProductCondition
        ? this.recommendedProductItem.attributes.ProductCondition
        : undefined,
      id: this.recommendedProductItem.id,
      relatedProductsImperative: this.recommendedProductItem.attributes?.RelatedProductsImperative
        ? this.recommendedProductItem.attributes.RelatedProductsImperative[0] === 'true'
        : false,
      productType: this.recommendedProductItem.attributes?.ProductType
        ? this.recommendedProductItem.attributes.ProductType[0]
        : undefined,
      serviceId: this.recommendedProductItem.attributes?.ServiceId
        ? this.recommendedProductItem.attributes.ServiceId[0]
        : undefined,
      serviceType: this.recommendedProductItem.attributes?.ServiceType
        ? this.recommendedProductItem.attributes.ServiceType[0]
        : undefined,
      purchasable: this.recommendedProductItem.attributes?.Purchasable
        ? this.recommendedProductItem.attributes?.Purchasable[0] === 'true'
        : true,
      addToCartButtonText: this.recommendedProductItem.attributes?.AddToCartButtonText
        ? this.recommendedProductItem.attributes?.AddToCartButtonText[0]
        : 'Add to Cart',
      addToCartOptionId: this.recommendedProductItem.attributes?.AddToCartOptionId
        ? this.recommendedProductItem.attributes?.AddToCartOptionId[0]
        : '0',
      tidBit: this.recommendedProductItem?.tidBit,
    } as TopSellingProduct;
  }
}

export default TopSellingDTO;
